import React from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { HIDDEN, FADE, HELP_PAGE, GAME_PAGE } from '../../HOME/const';
import ResetStatsIcon from '../../HOME/SVG/ResetStatsIcon';
import VolumeControl from '../../HOME/COMPONENTS/VolumeControl';
import HelpIcon from '../../HOME/SVG/HelpIcon';
import { setOver } from '../REDUX/actions';
import { goToPage, setGlobalOption, requestResetStats } from '../../HOME/REDUX/actions';

const Options = props => {
  const handleResetStats = e => {
    if (canResetStats()) {
      props.hideOptions();
      props.requestResetStats(true);
    }
  };

  const canResetStats = () => {
    const { stats } = props;
    return stats && stats.plays > 0;
  };

  const handleHelp = () => {
    props.hideOptions();
    props.setOver(false);
    props.goToPage(HELP_PAGE, GAME_PAGE);
  };

  const { op } = props;
  const optionsVisibility = op === HIDDEN ? 'none' : 'inline';

  return (
    <div className={`options ${op === FADE ? 'fadeout' : 'fadein-fast'}`} style={{ display: optionsVisibility }}>
      <div className="options-x" onClick={props.hideOptions}>
        ×
      </div>
      <div className={`options-item${canResetStats() ? '' : ' options-item-disabled'}`} onClick={handleResetStats}>
        <ResetStatsIcon width="30" />
        <span>reset stats</span>
      </div>
      <div className="options-item" onClick={handleHelp}>
        <HelpIcon width="30" />
        <span>how to play</span>
      </div>
      <VolumeControl />
    </div>
  );
};

function mapStateToProps({ sm, common }) {
  return { ...sm, ...common };
}

export default connect(
  mapStateToProps,
  { goToPage, requestResetStats, setGlobalOption, setOver }
)(Options);
